import React from 'react'
import { useTranslation } from 'react-i18next'
import errorImg from '../assets/noContentError.svg'
import CreateError from './CreateError'

export default function NoContentError() {
  const [t] = useTranslation()

  const errorInfo = {
    heading: t('centers.no-content', 'Is there a FamilySearch center in your stake?'),
    image: errorImg,
    paragraph: t('centers.no-content.fix', 'If so, we may still be adding it. Check back again later.'),
  }

  return <CreateError errorInfo={errorInfo} />
}
